import * as Sentry from '@sentry/react'

import { env } from '.'

export function setupSentry() {
  if (!env.EVT_SENTRY_DSN) return

  Sentry.init({
    dsn: env.EVT_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: env.EVT_MODE,
    enableLogs: true,
    ignoreErrors: [
      'AbortError',
      'The user aborted a request',
      'Fetch is aborted',
      'Network request failed',
      'cancelled',
    ],
  })
}
